export enum bankStatusEnum {
  BS_NR = 'Bank detection not run',
  BS_PEN = 'Yet to start',
  BS_RUN = 'Bank detection currently running',
  BS_BNK = 'Bank detected',
  BS_SRN = 'Subtype detection currently running',
  BS_SUB = 'Subtype detected',
}

